var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 5,
    fill: "#464646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9726 44.5925C29.6757 44.5925 31.0563 43.2418 31.0563 41.5757C31.0563 39.9095 29.6757 38.5588 27.9726 38.5588C26.2695 38.5588 24.8889 39.9095 24.8889 41.5757C24.8889 43.2418 26.2695 44.5925 27.9726 44.5925Z",
    fill: "#BF4949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 33.5308C31.1111 34.3309 30.7862 35.0982 30.2079 35.664C29.6296 36.2298 28.8453 36.5476 28.0274 36.5476C27.2096 36.5476 26.4252 36.2298 25.8469 35.664C25.2686 35.0982 24.9437 34.3309 24.9437 33.5308V14.4242C24.9437 13.6241 25.2686 12.8567 25.8469 12.291C26.4252 11.7252 27.2096 11.4073 28.0274 11.4073C28.8453 11.4073 29.6296 11.7252 30.2079 12.291C30.7862 12.8567 31.1111 13.6241 31.1111 14.4242V33.5308Z",
    fill: "#BF4949"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error_icon.5b5b91124b9dbe15d9579dbe20d9cb4d.svg";
export { ForwardRef as ReactComponent };